import { memo, useMemo } from "react";
import Box from "@mui/material/Box";
import { useRouter } from "next/router";

function SmallTitle({
  title,
  color,
  h1,
  h2,
  type,
  customeStyle,
  handleClick,
  animation = false,
}) {
  const router = useRouter();
  const locale = router.locale;

  const Component = h1 || h2 || "h3";

  const titleSx = useMemo(
    () => ({
      color: color ? color : "#2D317F",
      fontSize:
        type === "why-contact"
          ? { xs: "20px", sm: "24px" }
          : { xs: "24px", sm: "28px" },
      fontWeight: type === "why-contact" ? "normal" : "bold",
      textAlign: type === "why-contact" ? "center" : "",
      lineHeight: type === "why-contact" ? "1.3" : "",
      ...customeStyle,
    }),
    [color, type, customeStyle],
  );

  const lineStyle = useMemo(
    () => ({
      position: "absolute",
      width: "100%",
      mt: "3px",
      height: "5px",
      objectFit: "cover",
      objectPosition: locale === "en" ? "right" : "left",
      transform: locale === "en" ? "scaleX(-1)" : "scaleX(1)",
    }),
    [locale],
  );

  return (
    <Box
      data-aos={
        animation ? (locale === "ar" ? "fade-right" : "fade-left") : null
      }
      data-aos-delay={animation ? "500" : "0"}
      sx={{
        position: "relative",
        display: "inline-block",
      }}
    >
      <Box onClick={handleClick} component={Component} sx={titleSx}>
        {title}
      </Box>
      <Box
        sx={lineStyle}
        component="img"
        alt=""
        src="https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/line-main.webp"
        aria-hidden="true"
        // underline صغيرة جدًا: خليها eager عشان ما تعملش decode متأخر مع السكرول
        loading="eager"
        decoding="async"
      ></Box>
    </Box>
  );
}

export default memo(SmallTitle);
